import Http from '@helpers/Http';
import { Api } from '@apis/client';
import {  paths } from '@helpers/Constants';
import BrowserHistory from '@helpers/BrowserHistory';
import { ISelfClassDisableConfig } from '@apis/device/getClassDisableSelfConfig';
import { ISchoolClassDisableConfig } from '@apis/device/getClassDisableSchoolConfig';

import ConfirmModal from '@components/ConfirmModal';

//拨打电话流程
const call = async (sn: string, c?: string) => {
  const snCode = sn;
  const company = c || 'lingge';

  //1.是否设置手机号
  const { data } = await Http.post(Api.GetDeviceDetailInfo, {
    snCode,
    company,
  });
  //未输入-> 跳转至设备信息页面
  if (!data.phone) {
    return ConfirmModal.show({
      title: '无法拨打电话',
      text: '当前还没有设置学生证手机号',
      showCancelBtn: true,
      cancelBtnText: '取消',
      confirmBtnText: '设置',
      onConfirm: () => {
        BrowserHistory.push(
          `${PUBLIC_URL}${paths.deviceInfoEntry}?sncode=${snCode}`,
        );
      },
    });
  }
  //2.是否正在学校设置的禁用时间段内
  const { data: schoolConfig } = await Http.post(
    Api.GetClassDisableSchoolConfig,
    {
      sncode: snCode,
      company,
    },
  );
  if (schoolConfig?.status) {
    const canSchoolCanCallResult = schoolCanCallResult(schoolConfig);
    if (!canSchoolCanCallResult.canCall) {
      return ConfirmModal.show({
        title: `孩子正在上课${canSchoolCanCallResult.startTime} - ${canSchoolCanCallResult.endTime}`,
        text: '学校已开启上课免打扰功能，请暂时不要打扰~',
        confirmBtnText: '暂不打扰',
      });
    }
  }

  const { data: selfConfig } = await Http.post(Api.GetClassDisableSelfConfig, {
    sncode: snCode,
    company,
  });

  //3.是否在家长设置的自定义禁用时间段
  const canCall = selfCanCallResult(selfConfig);
  if (!canCall) {
    return ConfirmModal.show({
      title: '孩子正在上课',
      text: '已开启上课免打扰功能，请暂时不要打扰~',
      showCancelBtn: true,
      cancelBtnText: '去关闭',
      confirmBtnText: '暂不打扰',
      onCancel: (cancelType: string) => {
        if(cancelType === 'cancel') {
          BrowserHistory.push(
            `${PUBLIC_URL}${paths.deviceClassDisableSelf}?sncode=${snCode}&company=${company}`,
          );
        }
      },
    });
  }
  //4.是否可唤起系统电话
  // if (!isCubeApp()) {
  //   window.location.href = `tel://${data.phone}`;
  // } else {

  //判断是否有权限复制（很多浏览器都不支持）
  // const permissionsState = await navigator.permissions.query({ name: "clipboard-write" } as any);
  // console.log(permissionsState, 'permissionsState');
  return ConfirmModal.show({
    title: '请长按复制号码到电话中拨打',
    text: data.phone,
    // confirmBtnText: '复制号码',
    hideBtn: true,
    // onConfirm: () => {
    //   console.log(navigator.clipboard);
    //   if (navigator.clipboard) {
    //     navigator.clipboard.writeText(data.phone).then(() => {
    //       setTimeout(() => {
    //         Toast.show({
    //           title: '复制成功',
    //           type: 'strip',
    //         });
    //       })
    //     }).catch((err, ) => {
    //       setTimeout(() => {
    //         Toast.show({
    //           title: '复制失败，请长按复制文本',
    //           type: 'strip',
    //         });
    //       })
    //       console.log(err, 'err*****');
    //     });
    //   } else {
    //     setTimeout(() => {
    //       Toast.show({
    //         title: '暂不支持复制功能',
    //         type: 'strip',
    //       });
    //     })
    //   }
    // },
  });
};

//4:每天一致 5：5+2模式 6:每天不一致
const strategyConfig = {
  same: 4,
  workAndWeekDay: 5,
  notSame: 6,
};

const schoolCanCallResult = (config: ISchoolClassDisableConfig) => {
  let configResult = {
    canCall: true,
    startTime: '',
    endTime: '',
  };
  const days = config.days || [];
  const currentDay = new Date().getDay(); //从1开始 1-7
  //区分模式
  let findDay = null;
  if (strategyConfig.same === config.strategy) {
    findDay = days[0];
  }
  if (
    strategyConfig.notSame === config.strategy ||
    strategyConfig.workAndWeekDay === config.strategy
  ) {
    findDay = days.find(i => Number(i.day) === currentDay);
  }
  if (findDay) {
    const items = findDay.items;
    for (let i = 0; i < items?.length; i++) {
      let item = items[i];
      const currentTime = translateTimestamp(
        new Date().getHours() + ':' + new Date().getMinutes(),
      );
      const startTime = translateTimestamp(item.startTime);
      const endTime = translateTimestamp(item.endTime);
      if (currentTime >= startTime && currentTime <= endTime) {
        configResult.canCall = false;
        configResult.startTime = item.startTime;
        configResult.endTime = item.endTime;
        break;
      }
    }
  }
  return configResult;
};

//判断当前时间是否在自定义的禁用时间内（工作日时间dayIndexList和时间段 startTime - endTime）
const selfCanCallResult = (config: ISelfClassDisableConfig) => {
  let canCall = true;
  if (config?.isDisableDuringClass) {
    const timeConfigs = config.disableTimeConfigs;
    const currentDay = new Date().getDay() - 1; //从0开始 0-6
    if (timeConfigs?.length) {
      for (let i = 0; i < timeConfigs?.length; i++) {
        let item = timeConfigs[i];
        if (item.dayIndexList.indexOf(currentDay) >= 0) {
          const currentTime = translateTimestamp(
            new Date().getHours() + ':' + new Date().getMinutes(),
          );
          const startTime = translateTimestamp(item.startTime);
          const endTime = translateTimestamp(item.endTime);
          if (currentTime >= startTime && currentTime <= endTime) {
            canCall = false;
            break;
          }
        }
      }
    }
  }
  return canCall;
};

//将07:00格式转换为时间戳格式
const translateTimestamp = (time: string) => {
  let s = 0;
  if (time !== null) {
    const hour = time.split(':')[0];
    const min = time.split(':')[1];
    s = Number(hour) * 3600 + Number(min) * 60;
  }
  return s;
};

const callUtil = {
  call,
};

export default callUtil;
